import React from 'react';
import { Loader2, ShieldCheck, CheckCircle2, XCircle } from 'lucide-react';
import OpcoSelector from './OpcoSelector';

const inputCls = "w-full h-10 px-3 rounded-xl bg-[#F6F7FB] border border-[#EFF0F6] text-[13.5px] focus:bg-white focus:border-[#4F46E5] outline-none";
const monoCls = inputCls + " font-mono tracking-wider";
const labelCls = "block text-[12px] font-semibold text-[#4A4B63] mb-1";

/**
 * Tax section — TVA intracommunautaire (with VIES validation), IDCC list with
 * badges, and the OPCO selector.
 * Extracted from CompanyFormDialog (Vague 97.4).
 */
export default function CompanyTaxSection({ values, setValues, viesState, setViesState, checkVies }) {
  return (
    <section>
      <h3 className="text-[11.5px] font-semibold text-[#6B6C85] mb-2 tracking-wide uppercase">Fiscalité & Convention collective</h3>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className={labelCls}>TVA intracommunautaire</label>
          <div className="flex gap-2">
            <input
              data-testid="company-tva-intra"
              value={values.tva_intra}
              onChange={(e) => {
                setValues((v) => ({ ...v, tva_intra: e.target.value.toUpperCase() }));
                setViesState({ status: 'idle' });
              }}
              className={`flex-1 ${monoCls}`}
              placeholder="FRxxxxxxxxxxx"
            />
            <button
              type="button"
              onClick={checkVies}
              disabled={viesState.status === 'loading' || !values.tva_intra}
              data-testid="vies-check-btn"
              className="h-10 px-3 rounded-xl bg-white border border-[#EFF0F6] text-[12.5px] font-semibold text-[#4A4B63] hover:bg-[#F6F7FB] inline-flex items-center gap-1 disabled:opacity-60 whitespace-nowrap"
              title="Valider auprès du service VIES de l'Union européenne"
            >
              {viesState.status === 'loading' ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <ShieldCheck className="w-3.5 h-3.5" />}
              VIES
            </button>
          </div>
          <p className="text-[11px] text-[#8E8FA5] mt-1">Calculé automatiquement depuis le SIREN.</p>
          {viesState.status === 'valid' && (
            <div className="mt-1.5 text-[11.5px] text-[#0F766E] font-semibold inline-flex items-center gap-1" data-testid="vies-valid">
              <CheckCircle2 className="w-3.5 h-3.5" /> Validé par VIES{viesState.name ? ` · ${viesState.name}` : ''}
            </div>
          )}
          {viesState.status === 'invalid' && (
            <div className="mt-1.5 text-[11.5px] text-[#B91C1C] font-semibold inline-flex items-center gap-1" data-testid="vies-invalid">
              <XCircle className="w-3.5 h-3.5" /> Non validé par VIES
            </div>
          )}
        </div>
        <div>
          <label className={labelCls}>IDCC — Convention(s) collective(s)</label>
          <input
            data-testid="company-idcc"
            value={(values.liste_idcc || []).join(', ')}
            onChange={(e) => {
              const list = e.target.value.split(/[,;\s]+/).filter(Boolean);
              setValues((v) => ({ ...v, liste_idcc: list }));
            }}
            className={monoCls}
            placeholder="1388, 1516 …"
          />
          {(values.liste_idcc || []).length > 0 && (
            <div className="mt-1.5 flex flex-wrap gap-1" data-testid="idcc-badges">
              {values.liste_idcc.map((c) => (
                <span key={c} className="inline-flex items-center px-2 py-0.5 rounded bg-[#EEF2FF] text-[#4F46E5] text-[10.5px] font-semibold">IDCC {c}</span>
              ))}
            </div>
          )}
        </div>
      </div>
      <OpcoSelector
        idccs={values.liste_idcc || []}
        value={values.opco_id}
        onChange={(opco_id) => setValues((v) => ({ ...v, opco_id }))}
      />
    </section>
  );
}
